import { usePublicSettings } from '../../hooks/usePublicSettings';
import logoImage from '/src/assets/logo.png';

const Logo = () => {
  const { logoUrl, companyName } = usePublicSettings();
  const logoBucketUrl = import.meta.env.VITE_LOGO_BUCKET_URL;

  return logoUrl ? (
    <img src={logoBucketUrl + logoUrl} alt={companyName || 'Company Logo'} className="logo-image" />
  ) : 
    companyName ? <span>{companyName}</span> : <img src={logoImage} alt="Logo" className="logo-image" />;
};

export default Logo;
